import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-top: 1px solid #e1e0e7;\n  display: flex;\n  flex-direction: row;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  overflow-y: auto;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  &:hover {\n    ",
        " {\n      transition: color ",
        ";\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #827f9b;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text, LazyImage } from "@miro-site/core";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import SearchResultItem from "./SearchResultItem";
var Wrapper = styled.div.withConfig({
    componentId: "sc-521b1b47-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingLeft: [
            null,
            26,
            26,
            26
        ],
        paddingRight: [
            null,
            26,
            26,
            26
        ]
    });
});
var List = styled(Box).attrs({
    as: "ul"
}).withConfig({
    componentId: "sc-521b1b47-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingBottom: 18,
        paddingRight: [
            null,
            52
        ],
        paddingTop: 18,
        borderRight: [
            "none",
            "1px solid #e1e0e7"
        ],
        maxHeight: 288
    });
});
var Preview = styled.a.withConfig({
    componentId: "sc-521b1b47-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingBottom: 40,
        paddingLeft: 60,
        paddingTop: 40,
        width: 388,
        display: [
            "none",
            "block",
            "block",
            "block"
        ]
    });
}, Text, function(param) {
    var theme = param.theme;
    return theme.animation.transitionDuration;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBlueHover;
});
var NoResult = styled.div.withConfig({
    componentId: "sc-521b1b47-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingLeft: [
            10,
            34,
            34,
            34
        ],
        paddingRight: [
            10,
            34,
            34,
            34
        ],
        paddingTop: 24,
        paddingBottom: 24,
        fontSize: 18,
        lineHeight: 20
    });
});
var SearchDropdown = function(_param) {
    var _searchString = _param.searchString, searchString = _searchString === void 0 ? "" : _searchString, _searchResult = _param.searchResult, searchResult = _searchResult === void 0 ? [] : _searchResult, onSelectTemplate = _param.onSelectTemplate, isSearching = _param.isSearching, statusMessages = _param.statusMessages, activeIndex = _param.activeIndex, onItemHover = _param.onItemHover, props = _object_without_properties(_param, [
        "searchString",
        "searchResult",
        "onSelectTemplate",
        "isSearching",
        "statusMessages",
        "activeIndex",
        "onItemHover"
    ]);
    var ref = useState(0), selectedItem = ref[0], setSelectedItem = ref[1];
    var list = useRef(null);
    var listItem = useRef(null);
    var scrollToTop = function() {
        var ref, ref1;
        var elHeight = typeof ((ref = listItem.current) === null || ref === void 0 ? void 0 : ref.clientHeight) !== "undefined" ? (ref1 = listItem.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight : 0;
        var elOffset = elHeight * activeIndex;
        if (list.current) list.current.scrollTop = elOffset;
    };
    var ref1 = useState(false), scrollOff = ref1[0], setScrollOff = ref1[1];
    useEffect(function() {
        if (selectedItem > 0) {
            setSelectedItem(0);
        }
    }, [
        searchString
    ]);
    useEffect(function() {
        setSelectedItem(activeIndex);
        if (!scrollOff) scrollToTop();
    }, [
        activeIndex
    ]);
    if (!props.open) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            searchResult.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(List, {
                        ref: list,
                        children: searchResult.map(function(value, index) {
                            return /*#__PURE__*/ _jsx("li", {
                                ref: listItem,
                                children: /*#__PURE__*/ _jsx(SearchResultItem, _object_spread({
                                    isActive: selectedItem === index,
                                    onSelectTemplate: onSelectTemplate,
                                    onMouseEnter: function() {
                                        setScrollOff(true);
                                        if (typeof onItemHover !== "undefined") onItemHover(index);
                                    },
                                    onMouseLeave: function() {
                                        setScrollOff(false);
                                        if (typeof onItemHover !== "undefined") onItemHover(index);
                                    },
                                    onFocus: function() {
                                        if (typeof onItemHover !== "undefined") onItemHover(index);
                                    }
                                }, value), index)
                            }, index);
                        })
                    }),
                    searchResult[selectedItem] && /*#__PURE__*/ _jsxs(Preview, {
                        href: searchResult[selectedItem].href,
                        title: searchResult[selectedItem].title,
                        onClick: function(e) {
                            if (onSelectTemplate) {
                                e.preventDefault();
                                onSelectTemplate(searchResult[selectedItem]);
                            }
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                $styles: {
                                    position: "relative",
                                    width: 96,
                                    height: 62,
                                    marginBottom: 22
                                },
                                children: /*#__PURE__*/ _jsx(LazyImage, {
                                    lazyload: false,
                                    detectIntersection: false,
                                    width: 96,
                                    height: 62,
                                    name: searchResult[selectedItem].title,
                                    original: {
                                        "*": searchResult[selectedItem].preview
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                as: "div",
                                $variant: "p1medium",
                                $mb: 8,
                                children: searchResult[selectedItem].title
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                $variant: "p2",
                                children: searchResult[selectedItem].description
                            })
                        ]
                    })
                ]
            }),
            searchResult.length === 0 && isSearching && /*#__PURE__*/ _jsx(NoResult, {
                children: statusMessages.SEARCHING
            }),
            !isSearching && searchString.length >= 3 && searchResult.length == 0 && /*#__PURE__*/ _jsx(NoResult, {
                children: statusMessages.NO_RESULT
            }),
            !isSearching && searchString.length < 3 && searchResult.length == 0 && /*#__PURE__*/ _jsx(NoResult, {
                children: statusMessages.TYPE_MORE
            })
        ]
    });
};
export default SearchDropdown;
